import { AssayType } from './assayType-enum';
import { Chemical } from './chemical';
import { LabMDM } from './lab';
import { OperetionHistoryDTO } from './operationHistory';
export class LibraryConfiguration{
    _id: string;

    name:string;

    lab:LabMDM;

    process:string[];

    buffer:string;
    
    entryQcFAAssayType:AssayType;

    entryQCMinConc:number;

    entryQCMaxConc:number;
    
    entryQCTargetVolume:number;

    entryQCMaxVolumeToStartTheLibPrep:number;

    defaultAmountToStartTheLibPrep:number;

    entryQCMinDNARNAAmount:number;

    entryQCMinDQNRQN:number;

    libQCMinMolarity:number;

    libQCMinSize:number;

    libQCMaxSize:number;

    libQCFixedFragmentSize:number;

    libQcMminNumberOfConcMeasurements:number;

    libQcMmaxAllowedConcMeasurementDiffrence:number;

    preHybLibQCMinConc:number;

    preHybLibQCMinNumberOfConcMeasurements:number;

    preHybLibQCMaxAllowedConcMeasurementDifference:number;

    libQC1MinConc:number;
    
    libQC1MinNumberOfConcMeasurements:number;

    libQC1MaxAllowedConcMeasurementDifference:number;

    libQC2MinConc:number;

    libQC2MinNumberOfConcMeasurements:number;

    libQC2MaxAllowedConcMeasurementDifference:number;

    defaultValue:boolean;

    active:boolean;

    history:OperetionHistoryDTO[];

    creationDate:Date;

    lastModifiedDate:Date;

    version:number;

}